module.exports = __webpack_public_path__ + "static/media/czechBasedLogo.fe964dc2.png";